export default __webpack_public_path__ + "static/media/fail.851dc0cf.png";